module.exports = __webpack_public_path__ + "static/media/sidebar-arrow.0aa881d4.svg";